import { DragOverlay } from "@dnd-kit/core";
import type { TableProps } from "../../../../utils/local-antd";

import { DragIndexState } from "./types/DragIndexState";

interface EntiresTableWithDNDOverlayProps {
  columns: (NonNullable<TableProps["columns"]>[number] & { dragId: string })[];
  dragIndex: DragIndexState;
}

export const EntiresTableWithDNDOverlay: React.FC<
  EntiresTableWithDNDOverlayProps
> = ({ columns, dragIndex }) => {
  return (
    <DragOverlay>
      <th style={{ backgroundColor: "gray", padding: 16 }}>
        {
          columns.find((i) => i.dragId === dragIndex.active)
            ?.title as React.ReactNode
        }
      </th>
    </DragOverlay>
  );
};
